export default __webpack_public_path__ + "static/media/ulceras_por_presion.ff0683a8.pdf";